module.exports = "<h1>Next Total</h1>\r\n"